import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "currency", "id", "locale", "mode", "size", "variant", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Statistic.styles';
import FormatCurrency from '../FormatCurrency';
import FormatNumber from '../FormatNumber';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Tooltip from '../Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StatisticContext = createContext();

var Label = function Label(_ref) {
  var _tooltip$icon;

  var children = _ref.children,
      tooltip = _ref.tooltip;

  var _useContext = useContext(StatisticContext),
      mode = _useContext.mode;

  return _jsxs(Styled.Label, {
    children: [children, (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) && !(tooltip !== null && tooltip !== void 0 && tooltip.isDisabled) && _jsx(Tooltip, {
      content: tooltip.content,
      position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
      size: tooltip === null || tooltip === void 0 ? void 0 : tooltip.size,
      children: _jsx(Styled.TooltipTrigger, {
        icon: (_tooltip$icon = tooltip === null || tooltip === void 0 ? void 0 : tooltip.icon) !== null && _tooltip$icon !== void 0 ? _tooltip$icon : 'help',
        mode: mode,
        size: 12
      })
    })]
  });
};

var Content = function Content(_ref2) {
  var _value$initial, _value$current, _increment$format$has, _increment$format2;

  var actions = _ref2.actions,
      increment = _ref2.increment,
      isInline = _ref2.isInline,
      value = _ref2.value;

  var _useContext2 = useContext(StatisticContext),
      currency = _useContext2.currency,
      locale = _useContext2.locale,
      mode = _useContext2.mode,
      size = _useContext2.size,
      variant = _useContext2.variant;

  var hasIncrement = !(increment !== null && increment !== void 0 && increment.isHidden) && ((value === null || value === void 0 ? void 0 : value.initial) || (increment === null || increment === void 0 ? void 0 : increment.value));
  var initialValue = (_value$initial = value === null || value === void 0 ? void 0 : value.initial) !== null && _value$initial !== void 0 ? _value$initial : 0;
  var currentValue = (_value$current = value === null || value === void 0 ? void 0 : value.current) !== null && _value$current !== void 0 ? _value$current : 0;

  var calcIncrementValue = function calcIncrementValue() {
    var _increment$format;

    switch (increment === null || increment === void 0 ? void 0 : (_increment$format = increment.format) === null || _increment$format === void 0 ? void 0 : _increment$format.style) {
      case 'currency':
        return currentValue - initialValue;

      case 'decimal':
        return currentValue - initialValue;

      default:
        return (currentValue - initialValue) / initialValue * 100;
    }
  };

  var incrementValue = (increment === null || increment === void 0 ? void 0 : increment.value) || calcIncrementValue();
  var incrementStatus = incrementValue > 0 ? 'positive' : incrementValue < 0 ? 'negative' : 'neutral';

  var formatter = function formatter(displaySlot, format, val) {
    var formatStyle;

    if (displaySlot === 'value') {
      if (variant === 'kpi') {
        var _format$style;

        formatStyle = (_format$style = format === null || format === void 0 ? void 0 : format.style) !== null && _format$style !== void 0 ? _format$style : 'percent';
      } else {
        var _format$style2;

        formatStyle = (_format$style2 = format === null || format === void 0 ? void 0 : format.style) !== null && _format$style2 !== void 0 ? _format$style2 : 'decimal';
      }
    } else {
      var _format$style3;

      formatStyle = (_format$style3 = format === null || format === void 0 ? void 0 : format.style) !== null && _format$style3 !== void 0 ? _format$style3 : 'percent';
    }

    if (formatStyle === 'currency') {
      var _format$isCompact, _format$maximumFracti, _format$minimumFracti, _format$signDisplay, _format$signDisplay2;

      return _jsxs(_Fragment, {
        children: [displaySlot === 'increment' && variant === 'recorded' && '(', _jsx(FormatCurrency, {
          currency: currency,
          isCompact: (_format$isCompact = format === null || format === void 0 ? void 0 : format.isCompact) !== null && _format$isCompact !== void 0 ? _format$isCompact : false,
          locale: locale,
          maximumFractionDigits: (_format$maximumFracti = format === null || format === void 0 ? void 0 : format.maximumFractionDigits) !== null && _format$maximumFracti !== void 0 ? _format$maximumFracti : 0,
          minimumFractionDigits: (_format$minimumFracti = format === null || format === void 0 ? void 0 : format.minimumFractionDigits) !== null && _format$minimumFracti !== void 0 ? _format$minimumFracti : 0,
          signDisplay: displaySlot === 'increment' || variant === 'kpi' ? (_format$signDisplay = format === null || format === void 0 ? void 0 : format.signDisplay) !== null && _format$signDisplay !== void 0 ? _format$signDisplay : 'exceptZero' : (_format$signDisplay2 = format === null || format === void 0 ? void 0 : format.signDisplay) !== null && _format$signDisplay2 !== void 0 ? _format$signDisplay2 : 'auto',
          value: val
        }), displaySlot === 'increment' && variant === 'recorded' && ')']
      });
    } else {
      var _format$isCompact2, _format$maximumFracti2, _format$minimumFracti2, _format$signDisplay3, _format$signDisplay4;

      return _jsxs(_Fragment, {
        children: [displaySlot === 'increment' && variant === 'recorded' && '(', _jsx(FormatNumber, {
          isCompact: (_format$isCompact2 = format === null || format === void 0 ? void 0 : format.isCompact) !== null && _format$isCompact2 !== void 0 ? _format$isCompact2 : false,
          locale: locale,
          maximumFractionDigits: (_format$maximumFracti2 = format === null || format === void 0 ? void 0 : format.maximumFractionDigits) !== null && _format$maximumFracti2 !== void 0 ? _format$maximumFracti2 : 0,
          minimumFractionDigits: (_format$minimumFracti2 = format === null || format === void 0 ? void 0 : format.minimumFractionDigits) !== null && _format$minimumFracti2 !== void 0 ? _format$minimumFracti2 : 0,
          signDisplay: displaySlot === 'increment' || variant === 'kpi' ? (_format$signDisplay3 = format === null || format === void 0 ? void 0 : format.signDisplay) !== null && _format$signDisplay3 !== void 0 ? _format$signDisplay3 : 'exceptZero' : (_format$signDisplay4 = format === null || format === void 0 ? void 0 : format.signDisplay) !== null && _format$signDisplay4 !== void 0 ? _format$signDisplay4 : 'auto',
          value: val
        }), displaySlot === 'value' && formatStyle === 'percent' && _jsx(Styled.PercentSign, {
          children: "%"
        }), displaySlot === 'increment' && formatStyle === 'percent' && '%', displaySlot === 'increment' && variant === 'recorded' && ')']
      });
    }
  };

  var hasCarat = (_increment$format$has = increment === null || increment === void 0 ? void 0 : (_increment$format2 = increment.format) === null || _increment$format2 === void 0 ? void 0 : _increment$format2.hasCarat) !== null && _increment$format$has !== void 0 ? _increment$format$has : true;

  var renderCarat = function renderCarat() {
    var arrowSize = function arrowSize() {
      switch (size) {
        case 'small':
          return 16;

        case 'medium':
          return 18;

        case 'large':
          return 18;

        case 'xLarge':
          return 20;

        default:
          return 18;
      }
    };

    if (incrementStatus === 'positive') {
      return _jsx(Icon, {
        icon: "caret-up",
        size: arrowSize()
      });
    } else if (incrementStatus === 'negative') {
      return _jsx(Icon, {
        icon: "caret-down",
        size: arrowSize()
      });
    } else {
      return null;
    }
  };

  var renderActions = function renderActions() {
    return actions.map(function (action, index) {
      if (action !== null && action !== void 0 && action.icon) {
        var _action$isDisabled;

        return _jsx(Styled.Action, {
          children: _jsx(IconButton, {
            icon: action === null || action === void 0 ? void 0 : action.icon,
            isDisabled: (_action$isDisabled = action === null || action === void 0 ? void 0 : action.isDisabled) !== null && _action$isDisabled !== void 0 ? _action$isDisabled : false,
            onClick: action === null || action === void 0 ? void 0 : action.onClick,
            mode: mode,
            size: "small",
            variant: "ghost"
          })
        }, index);
      }

      if (action !== null && action !== void 0 && action.content) {
        return _jsx(Styled.Action, {
          children: action.content
        }, index);
      }

      return false;
    });
  };

  if (variant === 'kpi') {
    return _jsxs(Styled.Content, {
      isInline: true,
      variant: variant,
      children: [_jsx(Styled.Value, {
        children: formatter('value', increment === null || increment === void 0 ? void 0 : increment.format, incrementValue)
      }), hasCarat && _jsx(Styled.Increment, {
        status: incrementStatus,
        variant: variant,
        children: renderCarat()
      }), (actions === null || actions === void 0 ? void 0 : actions.length) && renderActions()]
    });
  } else {
    return _jsxs(Styled.Content, {
      isInline: isInline,
      variant: variant,
      children: [_jsxs(Styled.Value, {
        children: [formatter('value', value === null || value === void 0 ? void 0 : value.format, currentValue), (actions === null || actions === void 0 ? void 0 : actions.length) && renderActions()]
      }), hasIncrement && _jsxs(Styled.Increment, {
        status: incrementStatus,
        variant: variant,
        children: [formatter('increment', increment === null || increment === void 0 ? void 0 : increment.format, incrementValue), variant === 'status' && hasCarat && renderCarat()]
      })]
    });
  }
};

var SupportingText = function SupportingText(_ref3) {
  var children = _ref3.children;
  return _jsx(Styled.SupportingText, {
    children: children
  });
};

var Statistic = forwardRef(function (_ref4, ref) {
  var _cx;

  var children = _ref4.children,
      customClassName = _ref4.className,
      _ref4$currency = _ref4.currency,
      currency = _ref4$currency === void 0 ? 'GBP' : _ref4$currency,
      id = _ref4.id,
      _ref4$locale = _ref4.locale,
      locale = _ref4$locale === void 0 ? 'en-GB' : _ref4$locale,
      _ref4$mode = _ref4.mode,
      mode = _ref4$mode === void 0 ? 'light' : _ref4$mode,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'medium' : _ref4$size,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'status' : _ref4$variant,
      width = _ref4.width,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-statistic"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(StatisticContext.Provider, {
      value: {
        currency: currency,
        locale: locale,
        mode: mode,
        size: size,
        variant: variant
      },
      children: _jsx(Styled.Statistic, _objectSpread(_objectSpread({
        ref: ref,
        className: className,
        style: {
          width: width
        }
      }, rest), {}, {
        children: children
      }))
    })
  });
});
Statistic.displayName = 'Statistic';
Statistic.Label = Label;
Statistic.Content = Content;
Statistic.SupportingText = SupportingText;
export default Statistic;